import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from "@mui/material"
import Zoom from '@mui/material/Zoom';
import RtspPlayer from 'components/RtspPlayer';
import { getWebsocketHost, settingsConfig } from 'utils/commonFunc';
import { Paper, Typography } from "@mui/material";
import ApiService from 'services/ApiService';

export const PopupFacilityVds = ({ data }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)

    React.useEffect(() => {
        setTransitionIn(false)
        const key = setTimeout(() => {  
            setTransitionIn(true)
        }, 400);

        return () => clearTimeout(key)
    }, [data.get("id")])

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className='gisPopup'>
                <div className='popTit'>VDS ID <span className='id'>{data.get("id")}</span></div>
                <div className='popConts' style={{display: "grid", gridTemplateColumns: "0.6fr 1fr", gap: "12px", fontSize: "20px"}}>
                    <div className='subTxt'>상태</div>
                    <div className='gr'>{data.get("stat") == 1 ? '정상' : '장애'}</div>
                    <div className='subTxt'>설치위치</div>
                    <div>{data.get("name")}</div>
                </div>
            </div>
        </Zoom>
    )
}

export const PopupFacilityCctv = ({ data }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)
    const [url, setUrl] = React.useState()

    React.useEffect(() => {
        setTransitionIn(true)
    }, [])

    React.useEffect(() => {
        if(data.get("id")) {
            const serviceConfig = settingsConfig()
            setUrl(`${getWebsocketHost('/websocket/stream', serviceConfig.wsPortCctv)}?id=${data.get("id")}&width=${serviceConfig.cctvWidth}&height=${serviceConfig.cctvHeight}&fps=${serviceConfig.cctvFps}`)
        }
    }, [data.get("id")])

    return (
        <Zoom in={transitionIn} timeout={500} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className='gisPopup'>
                <div className='popTit'>스마트교차로 ID <span className='id'>{data.get("id")}</span></div>
                <div>
                    <RtspPlayer url={url} fps={settingsConfig().cctvFps}/>
                </div>
                <div className='popConts' style={{display: "grid", gridTemplateColumns: "0.6fr 1fr", gap: "12px", fontSize: "20px"}}>
                    <div className='subTxt'>상태</div>
                    <div className='gr'>{data.get("stat") == 1 ? '정상' : '장애'}</div>
                    <div className='subTxt'>설치위치</div>
                    <div>{data.get("name")}</div>
                </div>
            </div>            
        </Zoom>
    )
}

export const PopupFacilityVms = ({ data }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)
    const [dspBytes, setDspBytes] = React.useState(null)

    React.useEffect(() => {
        setTransitionIn(false)
        const key = setTimeout(() => {  
            setTransitionIn(true)
        }, 400);

        ApiService.get("newdashboard/gis/GetDspImage?vmsId="+data.get("id")).then(response => {
            if (response.status === 200) {
                const data = response.data;
                setDspBytes(data.dspBytes);
            }
        })

        return () => clearTimeout(key)
    }, [data])

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className='gisPopup'>
                <div className='popTit'>VMS ID <span className='id'>{data.get("id")}</span></div>
                <div>
                    <Paper elevation={3} sx={{ p: 0.5 }}>
                        {/* <Typography variant='h7'>{data.get("name")}</Typography> */}
                        <img alt='img' style={{
                            maxHeight:'192px',
                            display: 'block'
                        }} 
                        //src={`/api/dashboard/VmsImage?vmsId=${vms.id}`} 
                        src={`data:image/png;base64,${dspBytes}`}
                        />
                    </Paper>
                </div>
                <div className='popConts' style={{display: "grid", gridTemplateColumns: "0.6fr 1fr", gap: "12px", fontSize: "20px"}}>
                    <div className='subTxt'>상태</div>
                    <div className='gr'>{data.get("stat") == 1 ? '정상' : '장애'}</div>
                    <div className='subTxt'>설치위치</div>
                    <div>{data.get("name")}</div>
                </div>
            </div>
        </Zoom>
    )
}

export const PopupFacilityDsrc = ({ data }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)

    React.useEffect(() => {
        setTransitionIn(false)
        const key = setTimeout(() => {  
            setTransitionIn(true)
        }, 400);

        return () => clearTimeout(key)
    }, [data.get("id")])

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className='gisPopup'>
                <div className='popTit'>DSRC ID <span className='id'>{data.get("id")}</span></div>
                <div className='popConts' style={{display: "grid", gridTemplateColumns: "0.6fr 1fr", gap: "12px", fontSize: "20px"}}>
                    <div className='subTxt'>상태</div>
                    <div className='gr'>{data.get("stat") == 1 ? '정상' : '장애'}</div>
                    <div className='subTxt'>설치위치</div>
                    <div>{data.get("name")}</div>
                </div>
            </div>
        </Zoom>
    )
}

export const PopupFacilitySurf = ({ data }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)

    React.useEffect(() => {
        setTransitionIn(false)
        const key = setTimeout(() => {  
            setTransitionIn(true)
        }, 400);

        return () => clearTimeout(key)
    }, [data.get("id")])

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className='gisPopup'>
                <div className='popTit'>노면 ID <span className='id'>{data.get("id")}</span></div>
                <div className='popConts' style={{display: "grid", gridTemplateColumns: "0.6fr 1fr", gap: "12px", fontSize: "20px"}}>
                    <div className='subTxt'>상태</div>
                    <div className='gr'>{data.get("stat") == 1 ? '정상' : '장애'}</div>
                    <div className='subTxt'>설치위치</div>
                    <div>{data.get("name")}</div>
                </div>
            </div>
        </Zoom>
    )
}

export const PopupFacilityCrsr = ({ data }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)

    React.useEffect(() => {
        setTransitionIn(false)
        const key = setTimeout(() => {  
            setTransitionIn(true)
        }, 400);

        return () => clearTimeout(key)
    }, [data.get("id")])

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className='gisPopup'>
                <div className='popTit'>교차로 ID <span className='id'>{data.get("id")}</span></div>
                <div className='popConts' style={{display: "grid", gridTemplateColumns: "0.6fr 1fr", gap: "12px", fontSize: "20px"}}>
                    <div className='subTxt'>상태</div>
                    <div className='gr'>{data.get("stat") == 1 ? '정상' : '장애'}</div>
                    <div className='subTxt'>위치</div>
                    <div>{data.get("name")}</div>
                </div>
            </div>
        </Zoom>
    )
}